import { defineComponent as _defineComponent } from 'vue'

import useRoomInfo from '../../components/RoomHeader/RoomInfo/useRoomInfoHooks';
import copyIcon from '../common/icons/CopyIcon.vue';
import SvgIcon from '../common/base/SvgIcon.vue';
import { isMobile } from '../../utils/environment';
import {
  TUIConferenceStatus,
  TUIConferenceInfo,
} from '@tencentcloud/tuiroom-engine-js';
import { useI18n } from '../../locales';
type StatusMapType = {
  [key: number]: {
    text: string;
    className: string;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ConferenceDetail',
  props: {
    conferenceInfo: null,
    scheduleRoomDetailList: null
  },
  setup(__props: any) {

const props = __props as {
  conferenceInfo: TUIConferenceInfo;
  scheduleRoomDetailList: {
    title: string;
    content: string;
    isShowCopyIcon: boolean;
    status: TUIConferenceStatus | null;
    isShowStatus: boolean;
    isVisible: boolean;
  }[];
};

const { t } = useI18n();

const statusMap: StatusMapType = {
  [TUIConferenceStatus.kConferenceStatusRunning]: {
    text: 'Ongoing',
    className: 'status-running',
  },
};

const { onCopy } = useRoomInfo();

const getStatusTextAndClass = (status?: TUIConferenceStatus | null) => {
  if (!status) return { text: '', className: '' };
  return statusMap[status] || { text: '', className: '' };
};

return { __sfc: true,t, statusMap, props, onCopy, getStatusTextAndClass, copyIcon, SvgIcon, isMobile }
}

})